var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"red btn_small btn_inline2",attrs:{"type":"submit","name":"add_to_cart"},on:{"click":_vm.handleAddToCart}},[_vm._v("\n    Add Current Design to Cart\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }